export default __webpack_public_path__ + "static/media/token.25ce7fe5.svg";